import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "../src/assets/stylesheets/global.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { MobXProviderContext } from "mobx-react";
import onboardingStore from "mobXstore/onboardingStore";
import mealManagementStore from "mobXstore/mealManagementStore";
import homeStore from "mobXstore/homeStore";
import userStore from "mobXstore/userStore";
import invitationLinkStore from "mobXstore/invitationLinks";
import deliveryInfoStore from "mobXstore/deliveryInfoStore";
import paymentInfoStore from "mobXstore/paymentInfoStore";
import groupOrderStore from "mobXstore/groupOrderStore";
import restaurantStore from "mobXstore/restaurantStore";
import cartStore from "mobXstore/cartStore";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import placeOrderStore from "mobXstore/placeOrderStore";
import teamStore from "mobXstore/teamStore";
import * as Sentry from "@sentry/react";

const stores = {
  onboardingStore,
  mealManagementStore,
  userStore,
  invitationLinkStore,
  deliveryInfoStore,
  paymentInfoStore,
  groupOrderStore,
  restaurantStore,
  cartStore,
  homeStore,
  placeOrderStore,
  teamStore,
};

const root = ReactDOM.createRoot(document.getElementById("root"));

const queryClient = new QueryClient();

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN_KEY,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
    }),
    Sentry.replayIntegration(),
  ],
  environment: process.env.REACT_APP_NODE_ENV || "development",
  tracesSampleRate: 1.0,
});

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MobXProviderContext.Provider value={stores}>
        {/* <BrowserRouter> */}
        <App />
        {/* </BrowserRouter> */}
      </MobXProviderContext.Provider>
    </QueryClientProvider>
  </React.StrictMode>
);
